import { FormattedMessage } from "react-intl";
import MainView from "views/MainView";
import { _H5Event, handleFromAppParams, publicPath } from "request";
import { useEffect } from "react";
import { useIntlContext, SupportedLocales } from "views/IntlContext";
import { ContentSection, TroubleshootingSection } from "./components";

export const HealthConnect = () => {
  const { switchLanguage } = useIntlContext();

  let locale = SupportedLocales.English;
  useEffect(() => {
    const datas = {
      event: "GetTokenAndLanguage",
      pageName: "healthConnect",
      callback: (responseStr: any) => {
        const jsonData = handleFromAppParams(responseStr);
        switchLanguage?.(jsonData.lang);
        if (jsonData.lang === SupportedLocales.Chinese) {
          locale = SupportedLocales.Chinese;
        }
      },
    };
    _H5Event(datas);
  }, []);

  const contentSections = [
    {
      contentId: "helpCenter.healthConnect.content1",
      imageSrcs: [
        `${publicPath}/images/helpCenter/${locale}/healthconnect/img01.png`,
        `${publicPath}/images/helpCenter/${locale}/healthconnect/img02.png`,
      ],
      values: { name: <b>Health Connect</b> },
    },
    {
      contentId: "helpCenter.healthConnect.content2",
      imageSrcs: [
        `${publicPath}/images/helpCenter/${locale}/healthconnect/img03.png`,
        `${publicPath}/images/helpCenter/${locale}/healthconnect/img04.png`,
      ],
      values: {
        allow: (
          <b>
            <FormattedMessage id="helpCenter.healthConnect.content2.allow" />
          </b>
        ),
      },
    },
    {
      contentId: "helpCenter.healthConnect.content3",
      imageSrcs: [
        `${publicPath}/images/helpCenter/${locale}/healthconnect/img05.png`,
        `${publicPath}/images/helpCenter/${locale}/healthconnect/img06.png`,
      ],
    },
    {
      contentId: "helpCenter.healthConnect.content4",
      imageSrcs: [
        `${publicPath}/images/helpCenter/${locale}/healthconnect/img07.png`,
      ],
    },
  ];

  const troubleshootingSections = [
    {
      questionId: "helpCenter.healthConnect.troubleshooting.question1",
      answers: [
        "helpCenter.healthConnect.troubleshooting.question1.answer1",
        "helpCenter.healthConnect.troubleshooting.question1.answer2",
      ],
    },
    {
      questionId: "helpCenter.healthConnect.troubleshooting.question2",
      answers: ["helpCenter.healthConnect.troubleshooting.question2.answer1"],
    },
  ];

  return (
    <MainView backgroundClassName="bg-page dark:bg-black1b1f1e">
      <div className="pt-5 pr-9 pb-[80px] pl-6 flex flex-col">
        <p className="font-bold py-8 text-xl">
          <FormattedMessage id="helpCenter.healthConnect.title" />
        </p>
        {contentSections.map((section, index) => (
          <ContentSection
            key={index}
            contentId={section.contentId}
            imageSrcs={section.imageSrcs}
            values={section.values}
          />
        ))}
        <p className="font-bold mt-20 text-xl">
          <FormattedMessage id="helpCenter.healthConnect.troubleshooting" />
        </p>
        {troubleshootingSections.map((section, index) => (
          <TroubleshootingSection
            key={index}
            questionId={section.questionId}
            answers={section.answers}
          />
        ))}
      </div>
    </MainView>
  );
};
